module.exports = __webpack_public_path__ + "static/img/Moch Fadli Rahmadi-full.85a7d58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Moch Fadli Rahmadi-full.png
// module id = +pwX
// module chunks = 1